import { Box, CardMedia, CircularProgress } from "@mui/material";
import useGlobalContext from "hooks/globalData";
import { useQuery } from "react-query";
import { MediaItemSource } from "services/KnowfullyAdminClient";
import { MetaValuePreviewProps } from "pages/AttributesPage/CustomAttributeComponents/metaValueComponents";

const styles = {
  image: { width: 150, height: "auto", border: "1px solid lightgrey" },
};

export function MediaLibraryImagePreview({
  metaValueName,
  attributeMetaValues,
}: MetaValuePreviewProps) {
  const { mediaService } = useGlobalContext();

  const mediaLibraryItemId = attributeMetaValues?.find(
    (m) => m.name === metaValueName,
  )?.value;

  const { data: mediaItem, isLoading } = useQuery(
    ["mediaService.getItem", mediaLibraryItemId],
    () =>
      mediaService.getItem(mediaLibraryItemId!, MediaItemSource.MediaLibrary),
    { enabled: !!mediaLibraryItemId },
  );

  const fileUrl = mediaItem?.data?.fileUrl;

  if (isLoading) return <CircularProgress size={24} />;
  if (!fileUrl) return null;

  return (
    <Box>
      <CardMedia component="img" image={fileUrl} sx={styles.image} />
    </Box>
  );
}
